// extracted by mini-css-extract-plugin
module.exports = {"overlay":"Dialog__overlay___1ATSZ","container":"Dialog__container___1gQ3w","header":"Dialog__header___nUrDv"};